/**
 * 予約情報取得API store サービス
 *
 */
import { Injectable } from '@angular/core';
import {
  GetOrderState,
  GetOrderStore,
  resetGetOrder,
  selectGetOrderState,
  setGetOrderFromApi,
} from '@common/store/get-order';
import { selectServicingCommonState } from '@common/store/servicing-common';
import { Store, select } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { filter, map, pairwise } from 'rxjs/operators';
import { GetOrderRequest, DefaultService as ServicingApiService } from 'src/sdk-servicing';

/**
 * 予約情報取得API store サービス
 *
 * store情報
 * @param getOrderData @see GetOrderState
 */
@Injectable()
export class GetOrderStoreService {
  constructor(private _store: Store<GetOrderStore>, private api: ServicingApiService) {}

  private _result$ = this._store.pipe(
    select(selectGetOrderState),
    pairwise(),
    filter(([prev, curr]) => prev.isPending === true && curr.isPending === false),
    map(([_, cur]) => cur)
  );

  get success$(): Observable<GetOrderState> {
    return this._result$.pipe(filter((state) => state.isFailure === false));
  }

  get failure$(): Observable<GetOrderState> {
    return this._result$.pipe(filter((state) => state.isFailure === true));
  }

  public getGetOrderObservableOnce() {
    return firstValueFrom(this._store.select(selectGetOrderState).pipe(map((pnrState) => pnrState.model?.data)));
  }

  public getServicingCommonObservableOnce() {
    return firstValueFrom(this._store.select(selectServicingCommonState).pipe(map((state) => state.model?.getOrder)));
  }

  public resetGetOrder() {
    this._store.dispatch(resetGetOrder());
  }

  public setGetOrderFromApi(request: GetOrderRequest) {
    this._store.dispatch(
      setGetOrderFromApi({
        call: this.api.ordersGetOrderPost(request),
      })
    );
  }
}
